<template>
  <el-container  style="display: block;">

    <el-row    style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">
        <el-row :span="2" style="margin-top: 30px;">

            <el-row :span="2" style="margin-top: 30px;">
                指令:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
            </el-row>



            <el-row :span="2" style="margin-top: 30px;">
                <el-button type="primary" style="background-color: #409eff;" @click="doadd()" round>添加</el-button>
            </el-row>
        </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

              <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
          </el-row>





      </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">

            <el-table-column

              width="400"
              label="指令"
               >
               <template slot-scope="scope">
                   <div @click="dis(scope.row.id,1,scope.row.name)">{{scope.row.name}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="400"
              label="操作"
               >
               <template slot-scope="scope">

                 <el-button type="primary" style="background-color: #555555;" @click.native="del(scope.row.id)">删除</el-button>

               </template>
            </el-table-column>
            </el-table>
          </template>

        </el-row>






    </el-row>
    <el-dialog
      title="修改指令"
      :visible.sync="changeVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="cname"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="changeVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>




  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         list:[],
         changeVisible:false,
         j_id:this.$route.query.id,
         name:'',
         seachName:'',
         cname:'',
         cid:0,
         t:0




      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{


    dis(id,t,name){
      this.cid = id
      this.t = t
      this.cname = name

      this.changeVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	data:{
      		id:this.cid,
          name:this.cname,
          t:this.t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yquanweimChange'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.cid = 0

           this.changeVisible = false
           this.loadList();
      	}else{

      	}
       })
       .catch(err=>{

       });
    },



    seach(){
      this.loadList();
    },


    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          j_id:this.j_id,
          name:this.seachName


      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yquanweimList'
      })
      .then(res=>{

        this.list = res.data.data;




      })
      .catch(err=>{

      });
    },


    doadd(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.name == ''){
        this.msg('请填写名称','error')
        return false
      }



      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/yquanweimAdd',
      	params:{
      		name:this.name,
          j_id:this.j_id,


      	}
      })
      .then(res=>{
        this.$message({
        	type: 'success',
        	message: '添加成功'
        });
        this.name = ''


        this.loadList()
      })
      .catch(err=>{

      });
    },
    del(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yquanweimDel'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/yquanweim.vue